(function() {

    'use strict';

    /**
     * Html5 implementation for the VideoAbstract solution
     */

    var Feat = SAPO.Project.Video.Features;

    // early exit
    if (!Feat.supportsVideoElement && !Feat.hasFlash) { return; }


    var VPAIDHtml5AdUnit = function VPAIDHtml5AdUnit(o) {
        // console.log('VPAIDHtml5AdUnit!', o);

        this._handlers = {};
        this._ctn = o.container;

        var pair = o.video.extras;
        // log(pair);

        var that = this;
        this._awState = {};

        var cb = function(aw) {
            //log('VPAID READY');



            var vpaidEl = o.container.lastChild;
            that._el = vpaidEl;

            vpaidEl.style.position = 'absolute';
            vpaidEl.style.left = 0;
            vpaidEl.style.top  = 0;

            setTimeout(that.resize.bindObj(that), 500);

            that._aw = aw;

            o.onReady(that);
        };

        pair.builder( pair.item , o.container , cb);
    };

    VPAIDHtml5AdUnit.prototype = {
        // EVENTS

        resize: function(dims) {
            // log('RESIZE CALLED WITH', dims);
            if (!dims) {
                dims = [this._ctn.offsetWidth, this._ctn.offsetHeight];
            }
            this._el.setAttribute('width',  dims[0]); // TODO THIS SHOULD NOT BE REQUIRED
            this._el.setAttribute('height', dims[1]);
            this._aw.resizeAd(dims[0], dims[1]);
        },

        addEventListener: function(evType, cb) {
            var bag = this._handlers[evType];
            if (!bag) {
                this._handlers[evType] = [cb];
            }
            else {
                bag.push(cb);
            }
        },

        removeEventListener: function(evType, cb) {
            var bag = this._handlers[evType];
            if (!bag) { return; }
            for (var i = 0, f = bag.length; i < f; ++i) {
                if (bag[i] === cb) {
                    bag.splice(i, 1);
                    --i;
                }
            }
        },

        fire: function(evType, val) {
            var bag = this._handlers[evType];
            if (!bag) { return; }
            for (var i = 0, I = bag.length, cb; i < I; ++i) {
                cb = bag[i];
                if (val !== undefined) {
                    cb({type: evType, value: val});
                }
                else {
                    cb({type: evType});
                }
            }
        },



        // LOAD AND PLAY STATE

        canAutoplay: function() {
            return true;
        },

        unload: function() {
            // console.log('NOT IMPLEMENTED!');
        },

        load: function(/*src, type, startPlaying, extras*/) {
            //log(src, type, startPlaying, extras);
            // console.log('NOT IMPLEMENTED!');
        },

        isPlaying: function() {
            return this._awState ? this._awState.playing : false;
        },

        play: function() {
            this._aw.resumeAd();
            // this.fire('play');
        },

        pause: function() {
            this._aw.pauseAd();
            // this.fire('pause');
        },



        // TIME-RELATED

        getCurrentTime: function() {
            return this._aw.getAdDuration() - this._aw.getAdRemainingTime();
        },

        setCurrentTime: function(/*t*/) {
            //this._aw.setCurrentTime(t); // NO VPAID API FOR THIS
        },

        getDuration: function() {
            try {
                return this._aw.getAdDuration();
            } catch (ex) {
                return 10;
            }
        },

        getCache: function(/*asRatio*/) {
            return {start:0, end:1, length:1};
        },

        isLive: function() {
            return false;
        },

        isReady: function() {
            return !!this._aw;
        },



        // VOLUME-RELATED

        getVolume: function() {
            return this._aw.getAdVolume();
        },

        setVolume: function(v) {
            try {
                this._aw.setAdVolume(v);
            } catch (ex) {
                //log('setVolume('+v+') failed');
            }
            /*if (this._aw) {
                this._aw.setAdVolume(v);
            }*/
        },



        // SIZE

        getVideoSize: function() {
            return [
                this._aw.getAdWidth(),
                this._aw.getAdHeight()
            ];
        },



        // DOM

        getElement: function() {
            return this._el;
        },

        kill: function() {
            this._el.parentNode.removeChild(this._el);
        }
    };



    // this method is static and regular
    VPAIDHtml5AdUnit.canMimeTypeBePlayed = VPAIDHtml5AdUnit.prototype.canMimeTypeBePlayed = function(mimeType) {
        return mimeType === 'text/javascript' || mimeType === 'application/javascript';
    };



    SAPO.namespace('Project.Video.Controllers');
    SAPO.Project.Video.Controllers.VPAIDHtml5AdUnit = VPAIDHtml5AdUnit;

    SAPO.Project.Video.Controllers.videoImpls['vpaid_html5_ad_unit'] = VPAIDHtml5AdUnit;

})();
